import React from "react";
import {Colors} from "../../../../../../styles";

export const IconTopViewWallArea = function() {
	const fill = Colors.SIMPROBLUE;
	return (
		<svg width="24px" height="24px" viewBox="0 0 24 24">
			<path fill={fill}
				  d="M2,4a1,1,0,0,1,1-1H21a1,1,0,0,1,1,1V6a1,1,0,0,1-1,1H20v2h1a1,1,0,0,1,0,2H20v2h1a1,1,0,0,1,0,2H20v2h1a1,1,0,0,1,1,1v2a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V18a1,1,0,0,1,1-1H4V15H3a1,1,0,0,1,0-2H4V11H3a1,1,0,0,1,0-2H4V7H3A1,1,0,0,1,2,6ZM6,7V17H18V7Z"/>
		</svg>
	);
};
